import useReveal from "@/hooks/useReveal";
import { ShieldCheck, Lock, Eye } from "lucide-react";

const PrivacySection = () => {
  const [ref, isVisible] = useReveal();

  return (
    <section
      ref={ref}
      data-testid="privacy-section"
      className="py-20 md:py-32"
      style={{ backgroundColor: "#131E1E" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`max-w-3xl mx-auto text-center reveal-section ${isVisible ? "visible" : ""}`}>
          <div className="w-14 h-14 rounded-2xl bg-white/[0.08] flex items-center justify-center mx-auto mb-8">
            <ShieldCheck className="w-6 h-6 text-[#7EBDBC]" strokeWidth={1.5} />
          </div>
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-[#7EBDBC] mb-5">
            Privacy & control
          </p>
          <h2
            data-testid="privacy-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight leading-tight text-white mb-8"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            Built with privacy and control in mind
          </h2>
          <p
            data-testid="privacy-body"
            className="text-base md:text-lg text-white/70 leading-relaxed mb-12"
          >
            LumeroFlow is designed with secure access, clinic-level separation, and clinician-controlled review workflows, helping practices adopt AI documentation without losing oversight.
          </p>
          <div className="grid sm:grid-cols-3 gap-6 md:gap-8">
            {[
              { icon: Lock, title: "Secure access", desc: "Role-based permissions and clinic-level data separation" },
              { icon: Eye, title: "Clinician review", desc: "AI notes are always reviewed and approved by the clinician" },
              { icon: ShieldCheck, title: "Data control", desc: "Your clinic data stays under your control at all times" },
            ].map((item, i) => (
              <div
                key={i}
                data-testid={`privacy-feature-${i}`}
                className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-6 md:p-8 text-left"
              >
                <item.icon className="w-5 h-5 text-[#7EBDBC] mb-4" strokeWidth={1.5} />
                <h3
                  className="text-base font-medium text-white mb-2"
                  style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                >
                  {item.title}
                </h3>
                <p className="text-sm text-white/50 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacySection;
